import React from "react";
import { Helmet } from "react-helmet-async";
import { site } from "../data/mock";

const ORIGIN = "https://annhome.com.vn";

export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd,
  publishedTime,
  breadcrumbs,
  noindex = false,
}) {
  const fullTitle = title ? `${title} - ${site.name}` : site.title;
  const desc = description || site.description;
  const url = `${ORIGIN}${path}`;
  const raw = image || site.ogImage;
  const img = raw.startsWith("http") ? raw : `${ORIGIN}${raw}`;
  const isOgBanner = raw.startsWith("/og-");

  const breadcrumbLd =
    breadcrumbs && breadcrumbs.length
      ? {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((b, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: b.name,
            ...(b.path ? { item: `${ORIGIN}${b.path}` } : {}),
          })),
        }
      : null;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="vi" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        }
      />

      <meta property="og:site_name" content={site.name} />
      <meta property="og:locale" content="vi_VN" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:alt" content={fullTitle} />
      {isOgBanner && <meta property="og:image:width" content="1200" />}
      {isOgBanner && <meta property="og:image:height" content="630" />}
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
      {breadcrumbLd && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      )}
    </Helmet>
  );
}

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: "Ann Home",
  description: site.description,
  image: `${ORIGIN}${site.ogImage}`,
  logo: `${ORIGIN}/logo512.png`,
  url: ORIGIN,
  telephone: site.phone,
  email: site.email,
  servesCuisine: ["Healthy", "Eat Clean", "Salad", "Low carb"],
  priceRange: "35.000\u0111 - 70.000\u0111",
  address: {
    "@type": "PostalAddress",
    streetAddress: site.address,
    addressLocality: "H\u1ed3 Ch\u00ed Minh",
    addressCountry: "VN",
  },
  openingHours: "Mo-Su 07:00-20:00",
  sameAs: [site.facebook],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.8",
    reviewCount: "126",
  },
};

export { ORIGIN };
